export const customEnv = {
  pondIndividual: 'POND_INDIVIDUAL',
  correoSoporte: 'portal_calificaciones@duoc.cl'
}
